import { tablet } from "../../../mediaQueries";

const styles = (theme) => ({
  root: {
    height: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "stretch",
    paddingLeft: "4rem",
    [theme.breakpoints.up(theme.breakpoints.values.xs + 1600)]: {
      paddingLeft: 0,
      justifyContent: "center",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
      padding: "0 1rem",
      justifyContent: "center",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      flexDirection: "column",
      height: "auto",
    },
  },
  imageFade: {
    opacity: 0.2,
    filter: "grayscale(1)",
  },
  span: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    alignItems: "center",
    marginRight: "2rem",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      margin: "0",
    },
  },
  listSpan: {
    display: "flex",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 2.5s cubic-bezier(.4,.28,0,1.03)",
    alignItems: "flex-start",
    marginBottom: "50px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      flexDirection: "column",
      alignItems: "center",
      margin: "auto",
    },
  },
  btn: {
    cursor: "none !important",

    borderRadius: "0",
    border: "2px solid #0045EA",
    padding: "12px 20px",
    transform: "scale(0.9)",
    textTransform: "none",
    lineHeight: "16px",
    fontSize: "14px",
    color: "#0045EA",
    fontFamily: "Aktiv Grotesk",
    fontWeight: "500",
    margin: "0",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      marginTop: "20px",
    },
  },
  p: {
    color: "#575452",
    margin: 0,
    letterSpacing: "0.08em",
    marginBottom: "1rem",
    fontFamily: "Aktiv Grotesk",
    textTransform: "uppercase",
    lineHeight: "140%",
  },
  imageWrap: {
    display: "flex",
    flexDirection: "column",
    transition: "opacity 3s cubic-bezier(.4,.28,0,1.03)",
    opacity: 0,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      marginTop: "25px",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  image: {
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
      width: "100%",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
      width: "calc(100vw - 1rem)",
    },
    transition: "all 0.3s",
  },
});

export default styles;
